import { render, staticRenderFns } from "./info_input.vue?vue&type=template&id=d88149e4&scoped=true&"
import script from "./info_input.vue?vue&type=script&lang=js&"
export * from "./info_input.vue?vue&type=script&lang=js&"
import style0 from "./info_input.vue?vue&type=style&index=0&id=d88149e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88149e4",
  null
  
)

export default component.exports